// item 1449 (Chad, project page: "nothing aligns down the page in the different sections like it
// was all thrown together… we are focused on organization and making sure nothing is over the top
// or placed in random locations" — tags and styling stay exactly as they are) — ONE set of column
// positions for the document ledgers. Every ledger keeps its own columns and look; they just land
// at the same x down a project page:
//
//   [☐] IDENTITY 140 | CREATED 110 | SLOT 3 140 | SLOT 4 130 | STATUS 160 | … | actions 220
//   (= 940px with the checkbox: fits the project page at a 1440 viewport with the sidebar open, so the
//   pinned actions column doesn't kick in on a laptop; invoices' PAYMENT + ENTRY still overflow there,
//   exactly as production does today)
//
// slot 3 = TYPE (proposals) / APPROVED BY (work orders) / FINALIZED BY (invoices)
// slot 4 = AMOUNT (proposals, invoices) / TYPE (work orders)
// Invoices' PAYMENT + ENTRY follow STATUS; the actions column is right-aligned on every table.
export const LEDGER_W = {
  id: '140px',
  created: '110px',
  slot3: '140px',
  slot4: '130px',
  slot34: '270px', // slots 3+4 together — a right-aligned AMOUNT here ends where slot 4 ends
  status: '160px',
  extra: '130px',
  actions: '220px',
} as const;

export default LEDGER_W;
